<div class="modal-header clone-modal-header">
  <h6 class="modal-title mb-0">Clone a Course</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body clone-modal-body">
  <form [formGroup]="cloneForm">
    <div class="clone-section mb-3">
      <div class="clone-section-title">From Course</div>
      <div class="row g-3 clone-field-row">
        <div class="col-12 col-md-3">
          <label class="clone-field-label">Exam Agency</label>
          <input class="form-control" [value]="sourceExamAgencyName" readonly />
        </div>
        <div class="col-12 col-md-3">
          <label class="clone-field-label">Course</label>
          <input class="form-control" [value]="sourceCourseName" readonly />
        </div>
        <div class="col-12 col-md-3">
          <label class="clone-field-label">Year</label>
          <input class="form-control" [value]="fromYear" readonly />
        </div>
        <div class="col-12 col-md-3">
          <label class="clone-field-label">Month</label>
          <input class="form-control" [value]="fromMonth || 'Not Selected'" readonly />
        </div>
      </div>
    </div>

    <div class="clone-section">
      <div class="clone-section-title">To Course</div>
      <div class="row g-3 clone-field-row">
        <div class="col-12 col-md-3">
          <label class="clone-field-label required-label">Exam Agency</label>
          <select
            class="form-select"
            formControlName="examAgency"
            (change)="loadCourses($event)"
            [ngClass]="cloneForm.get('examAgency')?.touched && cloneForm.get('examAgency')?.invalid ? 'red-border-required' : ''"
          >
            <option value="">Select Exam Agency</option>
            <option *ngFor="let agency of examAgencies" [value]="agency.Code">
              {{ agency.Description }}
            </option>
          </select>
        </div>

        <div class="col-12 col-md-3">
          <label class="clone-field-label required-label">Course</label>
          <select
            class="form-select"
            formControlName="course"
            [disabled]="!cloneForm.get('examAgency')?.value || loadingCourses"
            [ngClass]="cloneForm.get('course')?.touched && cloneForm.get('course')?.invalid ? 'red-border-required' : ''"
          >
            <option value="">Select Course</option>
            <option *ngFor="let course of courses" [value]="course.Code">
              {{ course.Description }}
            </option>
          </select>
        </div>

        <div class="col-12 col-md-3">
          <label class="clone-field-label required-label">Year</label>
          <select
            class="form-select"
            formControlName="year"
            [ngClass]="cloneForm.get('year')?.touched && cloneForm.get('year')?.invalid ? 'red-border-required' : ''"
          >
            <option value="">Select Year</option>
            <option *ngFor="let year of years" [value]="year.Code">
              {{ year.Name || year.Code }}
            </option>
          </select>
        </div>

        <div class="col-12 col-md-3">
          <label class="clone-field-label">Month</label>
          <select class="form-select" formControlName="month">
            <option value="">Select Month</option>
            <option *ngFor="let month of months" [value]="month.value">
              {{ month.label || 'None' }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer clone-modal-footer">
  <button
    type="button"
    class="btn btn-sm bl-btn"
    (click)="cloneCourse()"
  >
    {{ checkingCourseExists ? 'Checking...' : 'Clone' }}
  </button>
  <button type="button" class="btn btn-sm bg-light border" (click)="cancel()">Cancel</button>
</div>
